/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessModelCanvasArea = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The BusinessModelCanvasArea model module.
   * @module model/BusinessModelCanvasArea
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessModelCanvasArea</code>.
   * @alias module:model/BusinessModelCanvasArea
   * @class
   */
  var exports = function() {
    var _this = this;




























  };

  /**
   * Constructs a <code>BusinessModelCanvasArea</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessModelCanvasArea} obj Optional instance to populate.
   * @return {module:model/BusinessModelCanvasArea} The populated <code>BusinessModelCanvasArea</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Icon')) {
        obj['Icon'] = ApiClient.convertToType(data['Icon'], 'String');
      }
      if (data.hasOwnProperty('DefaultNameFI')) {
        obj['DefaultNameFI'] = ApiClient.convertToType(data['DefaultNameFI'], 'String');
      }
      if (data.hasOwnProperty('DefaultNameEN')) {
        obj['DefaultNameEN'] = ApiClient.convertToType(data['DefaultNameEN'], 'String');
      }
      if (data.hasOwnProperty('DefaultNameSE')) {
        obj['DefaultNameSE'] = ApiClient.convertToType(data['DefaultNameSE'], 'String');
      }
      if (data.hasOwnProperty('DefaultName')) {
        obj['DefaultName'] = ApiClient.convertToType(data['DefaultName'], 'String');
      }
      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionFI')) {
        obj['DefaultDescriptionFI'] = ApiClient.convertToType(data['DefaultDescriptionFI'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionEN')) {
        obj['DefaultDescriptionEN'] = ApiClient.convertToType(data['DefaultDescriptionEN'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionSE')) {
        obj['DefaultDescriptionSE'] = ApiClient.convertToType(data['DefaultDescriptionSE'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescription')) {
        obj['DefaultDescription'] = ApiClient.convertToType(data['DefaultDescription'], 'String');
      }
      if (data.hasOwnProperty('DescriptionFI')) {
        obj['DescriptionFI'] = ApiClient.convertToType(data['DescriptionFI'], 'String');
      }
      if (data.hasOwnProperty('DescriptionEN')) {
        obj['DescriptionEN'] = ApiClient.convertToType(data['DescriptionEN'], 'String');
      }
      if (data.hasOwnProperty('DescriptionSE')) {
        obj['DescriptionSE'] = ApiClient.convertToType(data['DescriptionSE'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('CompactViewX')) {
        obj['CompactViewX'] = ApiClient.convertToType(data['CompactViewX'], 'Integer');
      }
      if (data.hasOwnProperty('CompactViewY')) {
        obj['CompactViewY'] = ApiClient.convertToType(data['CompactViewY'], 'Integer');
      }
      if (data.hasOwnProperty('CompactViewWidth')) {
        obj['CompactViewWidth'] = ApiClient.convertToType(data['CompactViewWidth'], 'Integer');
      }
      if (data.hasOwnProperty('CompactViewHeight')) {
        obj['CompactViewHeight'] = ApiClient.convertToType(data['CompactViewHeight'], 'Integer');
      }
      if (data.hasOwnProperty('FullViewX')) {
        obj['FullViewX'] = ApiClient.convertToType(data['FullViewX'], 'Number');
      }
      if (data.hasOwnProperty('FullViewY')) {
        obj['FullViewY'] = ApiClient.convertToType(data['FullViewY'], 'Integer');
      }
      if (data.hasOwnProperty('FullViewWidth')) {
        obj['FullViewWidth'] = ApiClient.convertToType(data['FullViewWidth'], 'Number');
      }
      if (data.hasOwnProperty('FullViewHeight')) {
        obj['FullViewHeight'] = ApiClient.convertToType(data['FullViewHeight'], 'Integer');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Icon
   * @default ''
   */
  exports.prototype['Icon'] = '';
  /**
   * @member {String} DefaultNameFI
   * @default ''
   */
  exports.prototype['DefaultNameFI'] = '';
  /**
   * @member {String} DefaultNameEN
   * @default ''
   */
  exports.prototype['DefaultNameEN'] = '';
  /**
   * @member {String} DefaultNameSE
   * @default ''
   */
  exports.prototype['DefaultNameSE'] = '';
  /**
   * @member {String} DefaultName
   * @default ''
   */
  exports.prototype['DefaultName'] = '';
  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} DefaultDescriptionFI
   * @default ''
   */
  exports.prototype['DefaultDescriptionFI'] = '';
  /**
   * @member {String} DefaultDescriptionEN
   * @default ''
   */
  exports.prototype['DefaultDescriptionEN'] = '';
  /**
   * @member {String} DefaultDescriptionSE
   * @default ''
   */
  exports.prototype['DefaultDescriptionSE'] = '';
  /**
   * @member {String} DefaultDescription
   * @default ''
   */
  exports.prototype['DefaultDescription'] = '';
  /**
   * @member {String} DescriptionFI
   * @default ''
   */
  exports.prototype['DescriptionFI'] = '';
  /**
   * @member {String} DescriptionEN
   * @default ''
   */
  exports.prototype['DescriptionEN'] = '';
  /**
   * @member {String} DescriptionSE
   * @default ''
   */
  exports.prototype['DescriptionSE'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} CompactViewX
   * @default 0
   */
  exports.prototype['CompactViewX'] = 0;
  /**
   * @member {Integer} CompactViewY
   * @default 0
   */
  exports.prototype['CompactViewY'] = 0;
  /**
   * @member {Integer} CompactViewWidth
   * @default 0
   */
  exports.prototype['CompactViewWidth'] = 0;
  /**
   * @member {Integer} CompactViewHeight
   * @default 0
   */
  exports.prototype['CompactViewHeight'] = 0;
  /**
   * @member {Number} FullViewX
   * @default 0.0
   */
  exports.prototype['FullViewX'] = 0.0;
  /**
   * @member {Integer} FullViewY
   * @default 0
   */
  exports.prototype['FullViewY'] = 0;
  /**
   * @member {Number} FullViewWidth
   * @default 0.0
   */
  exports.prototype['FullViewWidth'] = 0.0;
  /**
   * @member {Integer} FullViewHeight
   * @default 0
   */
  exports.prototype['FullViewHeight'] = 0;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


